<template>

  <Header
    label="Aus Liebe zum Theater"
    headline="DAS DA-Tickets"
  />

  <div v-if="events.length" class="py-24 container">
    <EventsGrid :events="events" />
  </div>

  <Empty v-else text="Keine Veranstaltungen verfügbar" />

  <div class="pb-24 container">
    <BuyCoupon />
  </div>

</template>

<script>
import Layout from 'Web/Layouts/WithCart.vue';
import BuyCoupon from 'Web/Shared/BuyCoupon.vue';
import Empty from 'Web/Shared/Empty.vue';
import EventsGrid from 'Web/Shared/EventsGrid.vue';
import Header from 'Web/Shared/Header.vue';
import useMeta from '@/compose/meta';

export default {
  inheritAttrs: false,
  layout: Layout,
  components: {
    Empty,
    EventsGrid,
    BuyCoupon,
    Header,
  },
  props: {
    events: {
      type: Array,
      required: true,
    },
  },
  setup() {
    const { assign } = useMeta();

    assign({ title: 'DAS DA-Onlineshop - Tickets' });
  }
}
</script>
